module.exports = __webpack_public_path__ + "img/8.b5d75bf5.png";